// Cart Drawer
$(document).ready(function () {
  const cartIcon = document.querySelector(".cart__drawer");
  const cartDrawer = document.querySelector(".cart-drawer");
  if (cartIcon) {
    const cartToggler = [
      ".cart__drawer",
      ".cart-drawer .cart_overlay",
      ".cart-drawer .cart_d_close",
    ];
    setToggler(cartToggler);
  }

  function setToggler(cartToggler) {
    cartToggler.map((selector) => {
      document.querySelector(selector).addEventListener("click", (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        cartDrawer.classList.toggle("open_drawer");
        document.body.classList.toggle("overflow-hidden");
      });
    });
  }

  class CartQuantity extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.quantity = this.querySelector('input[name="quantity"]');
      this.plusBtn = this.querySelector("a.plus");
      this.minusBtn = this.querySelector("a.minus");
      this.removeBtn = this.querySelector(".cart_item_remove");
      this.timer = null;
      this.giftAdded = null;

      // console.log(this.quantity);

      this.quantity?.addEventListener("change", (e) => this.debounce());
      this.plusBtn?.addEventListener("click", (e) => this.debounce());
      this.minusBtn?.addEventListener("click", (e) => this.debounce());
      this.removeBtn?.addEventListener("click", (e) => this.updatecart(true, e.target.dataset.matchEbroiedry));
      this.addGiftProd.bind(this)
      this.removeProductwithRef.bind(this)
    }
    #activeFetch = null;
    #createAbortController() {
      if (this.#activeFetch) {
        this.#activeFetch.abort();
      }

      const abortController = new AbortController();
      this.#activeFetch = abortController;
      return abortController;
    }

    debounce() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => this.updatecart(), 300);
    }

    async updatecart(quantity, hasembroProd) {
      const abortController = this.#createAbortController();
      const newQuantity = this.querySelector('input[name="quantity"]');
      let changeVar;
      if (quantity) {
        const lineIndex = parseInt(this.dataset.index);
        if(hasembroProd){this.removeProductwithRef(lineIndex, parseInt(hasembroProd)); return;} 
        changeVar = {
          line: lineIndex,
          quantity: 0,
          sections: "cart-drawer",
        };
      } else {
        changeVar = {
          line: parseInt(this.dataset.index),
          quantity: parseInt(newQuantity.value),
          sections: "cart-drawer",
        };
      }
      console.log("Quantity value is:", changeVar);
      fetch(Shopify.routes.root + "cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(changeVar),
        signal: abortController.signal
      })
        .then((response) => response.json())
        .then((data) => {
          console.log("data=>", data);
          if (data.sections) {
            const html = new DOMParser().parseFromString(
              data.sections["cart-drawer"],
              "text/html"
            );
            this.updateHTML(html);
          } else {
            const massage = document.createElement("p");
            massage.textContent = data.message;
            this.append(massage);
            this.getCart();
          }
        })
        .catch((error) => {
          console.error("Change Quntity Error:", error);
        });

        // cartDrawerUpdate();
    }
    async updateHTML(html) {
       const gift_isin_cart = html.querySelector('.free_cart_gift_added');
       const cust_data_has = html.querySelector('.cart-free-gift')?.dataset.isinCart;
       const cust_data_not = document.querySelector('.cart-free-gift')?.dataset.isinCart;
      if(this.giftAdded && cust_data_has == 'noadd'){
        this.giftAdded = null;
      }
      if(!this.giftAdded && cust_data_has == 'hasadd' && cust_data_not == 'noadd' && !gift_isin_cart){
      //  await this.addGiftProd(html, cust_data_has);
      this.giftAdded = true;
      }

      
       const newHtml = html.querySelector(".cart-drawer");

      const selectors = Array.from(
        document.querySelectorAll("[data-cart-js-update]")
      );

      let isEmpty = newHtml?.querySelector(".empty-cart_drawer");
      let hasEmpty = document.querySelector(".empty-cart_drawer");
      let isContent = document.querySelector(".cart_items");
      if (isEmpty) {
        document.querySelector(".cart_drawer__inner").innerHTML =
          newHtml.querySelector(".cart_drawer__inner").innerHTML;
      }
      if (!isEmpty && !isContent) {
        document.querySelector(".cart_drawer__inner").innerHTML =
          newHtml.querySelector(".cart_drawer__inner").innerHTML;
      }

      selectors.forEach((cartSelector) => {
        const selectorKey = cartSelector.dataset.cartJsUpdate;
        const newContent = newHtml.querySelector(
          `[data-cart-js-update="${selectorKey}"]`
        );

        if (!newContent) return;

        if (cartSelector.tagName.toLowerCase() === "script") {
          const newScript = document.createElement("script");

          for (let attr of newContent.attributes) {
            newScript.setAttribute(attr.name, attr.value);
          }

          newScript.textContent = newContent.textContent;

          cartSelector.replaceWith(newScript);
        } else {
          cartSelector.innerHTML = newContent.innerHTML;
        }
      });
      const gift_bar = html.querySelector(".free_gift_bar");
      const ship_bar = html.querySelector(".free_ship_bar");
      if (gift_bar) {
        document
          .querySelector(".free_gift_bar")
          .style.setProperty("--progress", gift_bar.dataset.progress);
        document.querySelector(".free_gift_bar").dataset.progress =
          gift_bar.dataset.progress;
      }
      if (ship_bar) {
        document
          .querySelector(".free_ship_bar")
          .style.setProperty("--progress", ship_bar.dataset.progress);
        document.querySelector(".free_ship_bar").dataset.progress =
          ship_bar.dataset.progress;
      }

       const cartCount =
        newHtml.querySelector(".js-header-cart").dataset.cartCount;
        

      if(document.querySelector(".cart__drawer .text-link")){
        document.querySelector(
          ".cart__drawer .text-link"
        ).innerHTML = `Cart (${cartCount})`;
      }

      // console.log(html);
     
    }
    getCart() {
      fetch(Shopify.routes.root + "cart.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      })
        .then((response) => response.text())
        .then((data) => {
          // console.log("data=>", data);
          const html = new DOMParser().parseFromString(data, "text/html");
          this.updateHTML(html);
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }
    async addGiftProd(html, cust_data_has){
      console.log(this.giftAdded, cust_data_has)
      if(!this.giftAdded){   
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: {
          quantity: 1,
          id: 40617587408931,
          sections: "cart-drawer",
        },
        success: function (response) {
          const html = new DOMParser().parseFromString(
            response.sections["cart-drawer"],
            "text/html"
          );
          document.querySelector("cart-quantity").updateHTML(html);
        },
        error: function (error) {
          console.log("Gift not added");
        },
      });
      }
      else{
        return
      }
    }
  async removeProductwithRef(prodLine, refLine){
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      dataType: 'json',
      data: {
        line: prodLine, 
        quantity: 0
      },
      success: function(cart) {
        console.log('Cart Original Product Removed:');
         $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          dataType: 'json',
          data: {
            line: refLine, 
            quantity: 0,
            sections: "cart-drawer"
          },
          success: function(cart) {
            console.log('Cart Ref Product Removed:');
            const html = new DOMParser().parseFromString(cart.sections["cart-drawer"],"text/html");
            document.querySelector("cart-quantity").updateHTML(html);
          },
          error: function(error) {
            console.error('Error Ref Product Not Removed:', error);
          }
        });
      },
      error: function(error) {
        console.error('Error Original Product Not Removed:', error);
      }
    });
  }
  }
  customElements.define("cart-quantity", CartQuantity);
});